import React from "react";
import NumberFormat from 'react-number-format';


export function EnergiaDemandaHtml({
    ...props
}) {

    return (
        <>
            <NumberFormat thousandSeparator={true} suffix={' kW'}
                displayType={'text'}
                decimalSeparator=","
                          decimalScale={2}
                thousandSeparator="."
                value={props.value}
            />
        </>
    );
}
